<div class="container">
  <h1 class="page-title"
      [helpCenterButton]="manageInvUploadPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="manageInvUploadPermissionCode" [position]="'inline'" [lang]="currentLang">
      <span class="icon">
          <i class="fi fi-ss-search-alt"></i>
          {{"InvUploadMaintenance.Header" | translate}}
      </span>
  </h1>

  <p-card class="mt-4">
    <p-accordion>
        <p-accordionTab
                header="{{ 'Common.Form.Header' | translate }}"
                [selected]="true">
            <form [formGroup]="searchForm">
                <div class="p-fluid formgrid grid">
                    <div class="field {{'col-3'}} laas-calendar" >
                      <laas-calendar
                        #uploadDate
                        title="{{ 'InvUploadMaintenance.SearchCard.uploadDate' | translate }}"
                        [enableMaxDateIsToday]="true"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="uploadDateOnChange($event)">
                      </laas-calendar>
                    </div>
                </div>
                <br/>
                <div class="grid">
                   <div class="col">
                      <button
                              pButton
                              pRipple
                              [disabled]="searchForm.invalid"
                              label="{{ 'Common.Button.Search' | translate }}"
                              (click)="searchBtnClick()"
                              >
                      </button>
                      <button
                              pButton
                              pRipple
                              label="{{ 'Common.Button.Reset' | translate }}"
                              (click)="resetBtnClick()"
                              class="p-button-secondary ml-2"
                              >
                      </button>
                    </div>
                </div>
            </form>
        </p-accordionTab>
    </p-accordion>


    <div class="mt-2">
     <laas-data-table
        #invUploadResultTable
        [tableKey]="preferenceKey"
        [defaultColumns]="invUploadHeaderColumns"
        [loading]="isLoading"
        [value]="searchResults"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [lazy]="true"
        [paginator]="true" 
        [isShowCreateRowFunction]="false"
        [rows]="this.pageInfo.pageSize"
        [totalRecords]="this.pageInfo.totalRecords"
        [dataKey]="'seqNo'"
        >
        <ng-template pTemplate="caption">
          <div style="display: flex; gap: 1rem;">
            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <div style="display: flex; gap: 0.5rem; flex-wrap: nowrap;">
                <input type="file" #fileInput style="display: none" (change)="onInvUploadFileSelected($event)" accept=".xlsx">
                <button pButton pRipple
                  label="{{ 'InvUploadMaintenance.SearchCard.ChooseButton' | translate}}"
                  icon="pi pi-check"
                  class="p-button-success"
                  style="white-space: nowrap;"
                  (click)="fileInput.value = ''; fileInput.click()">
                </button>
                <button pButton pRipple
                  (click)="uploadInvUploadFile()"
                  [disabled]="!selectedFile"
                  class="p-button-primary"
                  style="white-space: nowrap;"
                  label="{{ 'InvUploadMaintenance.SearchCard.uploadButton' | translate}}">
                </button>
                <button pButton pRipple
                  (click)="onDownLoadExampleExcel()"
                  [disabled]="isLoadingExampleExcel"
                  class="p-button-success"
                  style="white-space: nowrap;"
                  label="{{ 'InvUploadMaintenance.SearchCard.downloadExample' | translate}}">
                </button>
              </div>
              <div *ngIf="selectedFile">
                {{ selectedFile.name }}
              </div>
            </div>
            <div>
              <small><strong class="p-invalid">
                1. {{ 'InvUploadMaintenance.Message.warningMessage1' | translate }}<br>
                2. {{ 'InvUploadMaintenance.Message.warningMessage2' | translate }}<br>
                3. {{ 'InvUploadMaintenance.Message.warningMessage3' | translate }}
              </strong></small>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container *ngTemplateOutlet="defaultTemplate; context: { $implicit: rowData, col: col }">    
             </ng-container>
          </td>
        </ng-template>
        <ng-template #defaultTemplate pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'date'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'status'">
              {{ getStatusTranslationKey(rowData[col.field]) | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'button'">
              <button pButton pRipple
                (click)="onDownloadDetailExcel(rowData.invUploadNo)"
                [disabled]="isLoadingDetailExcel.get(rowData.invUploadNo) || !isDetailDownloadAllowed(rowData.status)"
                icon="pi pi-download"
                class="p-button-success"
                >
              </button>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </ng-container>
          </ng-container>

        </ng-template>
      
      </laas-data-table>

    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="manageInvUploadPermissionCode"
  [lang]="currentLang">
</help-dock>
